export default "assets/images/logo-cheval-big-30aaf50d.png";